import { DeliveryConfigurationUi } from '@/components/Seller/SellerProfile/SalesAndDelivery/DeliveryConfiguration/DeliveryConfigurationUi';
import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import {
  UpdateSellerDeliveryDetailsRequest,
  UpdateSellerDeliverySchedulesRequest,
} from '@/data/api/model/sellers/SellersDto';
import {
  updateSellerDeliveryDetails,
  updateSellerDeliverySchedules,
} from '@/data/api/request/sellerRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  deliveryConfigurationUiToUpdateSellerDeliveryDetailsRequest,
  deliveryConfigurationUiToUpdateSellerDeliverySchedulesRequest,
} from './mapper';

export function useUpdateDeliveryConfiguration() {
  const queryClient = useQueryClient();
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  const mutation = useMutation({
    mutationFn: async (args: {
      sellerId: string;
      updateSellerDeliveryDetailsRequest: UpdateSellerDeliveryDetailsRequest;
      updateSellerDeliverySchedulesRequest: UpdateSellerDeliverySchedulesRequest;
    }) => {
      await updateSellerDeliveryDetails({
        sellerId: args.sellerId,
        updateSellerDeliveryDetails: args.updateSellerDeliveryDetailsRequest,
      });
      await updateSellerDeliverySchedules({
        sellerId: args.sellerId,
        updateSellerDeliverySchedulesRequest:
          args.updateSellerDeliverySchedulesRequest,
      });
    },
    onSuccess: () => showSnackSuccess('Datos actualizados'),
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({ queryKey: [cacheKeys.seller.list] });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.seller.deliveryDetails, variables.sellerId],
      });
    },
    onError: () => showSnackError('Error, no se pudo realizar la operación'),
  });

  const updateDeliveryDetails = (
    sellerId: string,
    uiState: DeliveryConfigurationUi
  ) => {
    mutation.mutate({
      sellerId,
      updateSellerDeliveryDetailsRequest:
        deliveryConfigurationUiToUpdateSellerDeliveryDetailsRequest(uiState),
      updateSellerDeliverySchedulesRequest:
        deliveryConfigurationUiToUpdateSellerDeliverySchedulesRequest(uiState),
    });
  };

  return { updateDeliveryDetails };
}
